import React, { useContext, useEffect, useState } from 'react';
import { Container, Typography, TextField, Button } from '@mui/material';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import api from '../../connection/Axios';
import { Link } from 'react-router-dom';
import {useNavigate} from 'react-router-dom'

import logo from '../../assets/logo.png'
import head from '../../assets/head.png'
import Header from '../../component/Header';

const Login = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showProgress, setShowProgress] = useState(false)
  const [goGetUser, setGoGetUser] = useState(false)
  const navigation = useNavigate()

  
  const data ={
      "username": email,
      "password": password
  }

const headersDefault = {headers: {"Content-Type": "application/json", "Access-Control-Allow-Origin": "*"}};

  function ValidateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      if (re.test(email) === true) {
          setShowProgress(true)
          GoLogin()
      } else {
          setSystemData({...systemData, erro: 'Verifique o email e senha digitados', typeError: 'error'})
      }
    }


  function GoLogin() {
      api.post('auth/login/', data, headersDefault).then(result => {
        console.log('LoginResult::  ', result)
          setUserData({...userData, token: result.data.token, username: email, role: result.data.role, companyId: result.data.companyId})
          setGoGetUser(true)
          navigation('/Dashboard')
          
      }).catch(error => {
        setShowProgress(false)
        setSystemData({...systemData, erro: error.message, typeError: 'error'})
      })
  }

  const headers = {
    'Authorization': `Bearer ${userData.token}`,
    'Content-Type': 'application/json',
    'Accept': '*/*'
}

const dataUser = {
  username: email
}

function GetUser() {
  api.post('auth/getUser', dataUser, headers).then(response => {
    setUserData({...userData, name: response.data.user.name, id: response.data.user.id, role: response.data.user.role})
    setSystemData({...systemData, logged: true})
  }).catch(function (error) {
    if (error.response) {
      setSystemData({...systemData, erro: error.response.message})
    }
    console.error(error.config);
  })
}

useEffect(()=>{
  if(goGetUser) {
    GetUser()
  }
}, [goGetUser])


  return (
    <>
      <Header />
      <div style={{marginTop: 40, display:'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column'}}>
        <div style={{fontWeight: 500, color: '#949494', fontSize: 14}}>Sistema Administrativo EHS</div>
        <TextField label="Email" onChange={(event) => setEmail(event.target.value)} value={email} variant="outlined" margin="normal" size="small" className='textField' />
        <TextField label="Password" value={password} onChange={(event) => setPassword(event.target.value)} type="password" variant="outlined" margin="normal" size="small" className='textField' />
        <Button variant="outlined" color="primary" onClick={()=>{ValidateEmail(email)}}>
          Login
        </Button>
        
        <div style={{height: 30,marginTop: 10,}}>
          {showProgress ? <CircularProgress color='secondary' style={{width: 30, height: 30}} /> : <></> }
        </div>
        
      </div>
    </>
  );
};

export default Login;